module.exports = __webpack_public_path__ + "media/testimonials/property-5-17acddfc.jpg";